<!--
 * @Author: your name
 * @Date: 2021-08-26 19:21:36
 * @LastEditTime: 2021-10-18 14:26:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\components\TinyEditor\Index.vue
-->
<template>
  <div class="tinymce-box">
    <Editor
      id="zwEdit"
      ref="zangwenBox"
      v-model="contentValue"
      :init="init"
      :disabled="disabled"
      @onClick="onClick"
      @onScroll="boxScrollChange"
    />
  </div>
</template>

<script>

// 引入tinymce编辑器
import Editor from '@tinymce/tinymce-vue'

// 引入node_modules里的tinymce相关文件文件
import tinymce from 'tinymce/tinymce' // tinymce默认hidden，不引入则不显示编辑器
import 'tinymce/themes/silver' // 编辑器主题，不引入则报错
import 'tinymce/icons/default' // 引入编辑器图标icon，不引入则不显示对应图标

// 引入编辑器插件（基本免费插件都在这儿了）
// import 'tinymce/plugins/advlist' // 高级列表
// import 'tinymce/plugins/anchor' // 锚点
import 'tinymce/plugins/autolink' // 自动链接
import 'tinymce/plugins/autoresize' // 编辑器高度自适应,注：plugins里引入此插件时，Init里设置的height将失效
import 'tinymce/plugins/autosave' // 自动存稿
import 'tinymce/plugins/charmap' // 特殊字符
import 'tinymce/plugins/code' // 编辑源码
// import 'tinymce/plugins/codesample' // 代码示例
// import 'tinymce/plugins/directionality' // 文字方向
// import 'tinymce/plugins/emoticons' // 表情
// import 'tinymce/plugins/fullpage' // 文档属性
// import 'tinymce/plugins/fullscreen' // 全屏
// import 'tinymce/plugins/help' // 帮助
// import 'tinymce/plugins/hr' // 水平分割线
// import 'tinymce/plugins/image' // 插入编辑图片
import 'tinymce/plugins/importcss' // 引入css
// import 'tinymce/plugins/insertdatetime' // 插入日期时间
// import 'tinymce/plugins/link' // 超链接
import 'tinymce/plugins/lists' // 列表插件
import 'tinymce/plugins/media' // 插入编辑媒体
import 'tinymce/plugins/nonbreaking' // 插入不间断空格
import 'tinymce/plugins/pagebreak' // 插入分页符
import 'tinymce/plugins/paste' // 粘贴插件
// import 'tinymce/plugins/preview'// 预览
// import 'tinymce/plugins/print'// 打印
import 'tinymce/plugins/quickbars' // 快速工具栏
import 'tinymce/plugins/save' // 保存
import 'tinymce/plugins/searchreplace' // 查找替换
// import 'tinymce/plugins/spellchecker'  //拼写检查，暂未加入汉化，不建议使用
// import 'tinymce/plugins/tabfocus' // 切入切出，按tab键切出编辑器，切入页面其他输入框中
// import 'tinymce/plugins/table' // 表格
// import 'tinymce/plugins/template' // 内容模板
// import 'tinymce/plugins/textcolor' // 文字颜色
// import 'tinymce/plugins/textpattern' // 快速排版
// import 'tinymce/plugins/toc' // 目录生成器
// import 'tinymce/plugins/visualblocks' // 显示元素范围
// import 'tinymce/plugins/visualchars' // 显示不可见字符
// import 'tinymce/plugins/wordcount' // 字数统计
export default {
  name: 'TEditor',
  components: {
    Editor
  },
  props: {
    isScroll: {
      type: Boolean
    },
    isDisable: {
      type: Boolean
    },
    boxId: {
      type: String,
      default: ''
    },
    boxRef: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'undo redo selectall searchreplace'
    },
    toolbar: {
      type: [String, Array],
      default: 'undo redo selectall searchreplace'
    },
    placeholder: {
      type: String,
      default: '在这里输入文字'
    },
    inline: {
      type: Boolean,
      default: false
    },
    contentFontSize: {
      type: Number,
      default: 14
    },
    contentBgColor: {
      type: String,
      default: '#f6f8f3'
    }
  },
  data() {
    return {
      init: {
        // readonly: this.isDisable, // 是否可编辑
        content_css: '/tinymce/skins/ui/jingshu.css', // 自定义富文本样式css
        language_url: '/tinymce/langs/zh_CN.js', // 引入语言包文件
        language: 'zh_CN', // 语言类型
        skin_url: '/tinymce/skins/ui/oxide', // 皮肤：浅色
        // skin_url: '/tinymce/skins/ui/oxide-dark',//皮肤：暗色
        toolbar_location: 'auto', // 工具栏位置  'auto' / 'bottom'
        toolbar_persist: true, // 内联模式始终显示工具栏
        toolbar_sticky: true, // 粘性工具栏（或停靠工具栏），在向下滚动网页直到不再可见编辑器时，将工具栏和菜单停靠在屏幕顶部。
        menubar: 'my1', // 关闭撤销上面工具栏
        menu: { // 自定义菜单
          my1: { title: '编辑', items: ' undo | redo | selectall | searchreplace' }
        },
        plugins: this.plugins, // 插件配置
        toolbar: false, // 工具栏配置，设为false则隐藏
        // menubar: 'file edit',  //菜单栏配置，设为false则隐藏，不配置则默认显示全部菜单，也可自定义配置--查看 http://tinymce.ax-z.cn/configure/editor-appearance.php --搜索"自定义菜单"
        inline: this.inline, // 开启内联样式
        height: '100%', // 注：引入autoresize插件时，此属性失效
        placeholder: this.placeholder,
        branding: false, // tiny技术支持信息是否显示
        resize: false // 编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号
        // statusbar: false,  //最下方的元素路径和字数统计那一栏是否显示
      },
      contentValue: this.value,
      timer: null
    }
  },
  computed: {
    contentStyle() {
      return `body { background-color: ${this.contentBgColor} !important; font-size: ${this.contentFontSize}px !important; }`
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.contentValue = newValue
      },
      deep: true
    },
    contentValue: {
      handler(newValue) {
        this.$emit('input', newValue)
      },
      deep: true
    },
    inline: {
      handler(v) {
        tinymce.init({})
      }
    },
    contentFontSize: {
      handler() {
        this.updateEditorStyle()
      }
    },
    contentBgColor: {
      handler() {
        this.updateEditorStyle()
      }
    }
  },
  mounted() {
    tinymce.init({})
    // 初始化编辑器样式,使用延时确保编辑器完全初始化
    setTimeout(() => {
      this.updateEditorStyle()
    }, 100)
    // this.$nextTick(() => {
    //   const editBox = document.getElementById('zwEdit')
    //   if (editBox) {
    //     editBox.addEventListener('scroll', this.boxScrollChange)
    //   }
    // })
  },
  methods: {
    boxScrollChange() {
      if (!this.isScroll) return
      const box1 = document.getElementById('zhongwenBox')
      // const box2 = this.$refs.zangwenBox
      const box2 = document.getElementById('zwEdit')
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // if (id === 'zangwenBox') {
        box1.scrollTop = box2.scrollTop
        // } else if (id === 'zhongwenBox') {
        // box2.scrollTop = box1.scrollTop
        // }
      }, 300)
    },
    // 更新编辑器样式
    updateEditorStyle() {
      const editor = tinymce.get('zwEdit')
      if (editor && editor.dom) {
        // 藏文需要额外的字号偏移
        const tibetanFontSize = this.contentFontSize + 9

        // 设置 CSS 变量
        const css = `
          :root {
            --editor-bg-color: ${this.contentBgColor};
            --editor-font-size: ${tibetanFontSize}px;
          }
          body {
            background-color: ${this.contentBgColor} !important;
            font-size: ${tibetanFontSize}px !important;
          }
        `

        // 移除所有旧的动态样式标签
        const styleTags = editor.dom.select('style[data-mce-dynamic-style]')
        styleTags.forEach(tag => editor.dom.remove(tag))

        // 添加新的样式标签
        const styleElement = editor.dom.create('style')
        styleElement.setAttribute('data-mce-dynamic-style', 'true')
        styleElement.innerHTML = css
        editor.getDoc().head.appendChild(styleElement)

        // 更新 body 的背景色和字体大小
        const body = editor.getBody()
        if (body) {
          body.style.setProperty('--editor-bg-color', this.contentBgColor)
          body.style.setProperty('--editor-font-size', tibetanFontSize + 'px')
          body.style.backgroundColor = this.contentBgColor
          body.style.fontSize = tibetanFontSize + 'px'
        }

        // 同时也添加样式到编辑器的 iframe 或容器
        const iframe = editor.getContainer().querySelector('iframe')
        if (iframe && iframe.contentDocument) {
          const iframeBody = iframe.contentDocument.body
          iframeBody.style.setProperty('--editor-bg-color', this.contentBgColor)
          iframeBody.style.setProperty('--editor-font-size', tibetanFontSize + 'px')
          iframeBody.style.backgroundColor = this.contentBgColor
          iframeBody.style.fontSize = tibetanFontSize + 'px'
        }

        // 更新编辑器边框颜色
        const editorElement = editor.getContainer()
        if (editorElement) {
          editorElement.style.backgroundColor = this.contentBgColor
          editorElement.style.borderColor = this.contentBgColor
        }
      }
    },
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    onClick(e) {
      this.$emit('onClick', e, tinymce)
    },
    // 清空内容
    clear() {
      this.contentValue = ''
    },
    // 获取选中的文字内容
    getSelectedText() {
      const editor = tinymce.get('zwEdit')
      if (editor) {
        return editor.selection.getContent({ format: 'text' })
      }
      return ''
    }
  }
}
</script>

<style lang="less">
.tinymce-box {
  width: 100%;
  height: 100%;
  > div {
    width: 100%;
    height: 100%;
    padding: 10px;
    overflow-y: auto;
    background-color: inherit;
    p {
      text-indent: 2em;
      letter-spacing: 1.5px;
      font-size: 25px;
      line-height: 46px;
      font-weight: 500;
    }
  }
  .tox-tinymce {
    padding-bottom: 0;
    .tox-menubar {
      background-color: #f6f8f3;
    }
    .tox-statusbar {
      display: none;
    }
    .tox-mbtn {
      background-color: skyblue !important;
      color: #fff;
      position: fixed;
      margin-top: 0;
      margin-left: -10px;
    }
  }
  .tox-edit-area__iframe {
    background-color: inherit !important;
  }
}
.tox-tinymce .tox-editor-header .tox-menubar {
  background-color: skyblue;
  button {
    > span {
      color: #fff;
    }
    &:hover {
      span {
        color: black;
      }
    }
  }
}

/* 动态背景色样式 */
.tox-tinymce {
  background-color: inherit !important;
}
.tox-editor-container {
  background-color: inherit !important;
}
.tox-edit-area {
  background-color: inherit !important;
}
</style>
